import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'FleetSearchPipe', pure: false })
export class FleetSearchPipe implements PipeTransform {
  transform(value, args?): Array<any> {
    let searchText = new RegExp(args, 'ig');
    if (value) {
      return value.filter(fleet => {
        if (fleet.rego) {
          return fleet.rego.search(searchText) !== -1;
        }
        else{
          return fleet.fleet_type_name.search(searchText) !== -1;
        }
      });
    }
  }
}